/*
Thumbnail → Variant Sync
Theme: Gist (Dawn-style variant-selects)
Purpose: Allow clicking gallery thumbnails to update the variant dropdown.
Default theme only supports variant → image direction.

Added: 2026-02-25
linked in theme.liquid - check this code there if it stops working
{% if template.name == 'product' %}
      {{ 'custom-variant-image.js' | asset_url | script_tag }}
    {% endif %}
Safe for theme updates (custom asset).
*/

(() => {
  function getProduct() {
    const el = document.querySelector('script[type="application/json"][data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function buildMediaToVariant(product) {
    const map = new Map();
    (product.variants || []).forEach(v => {
      const mediaId = v?.featured_media?.id ? String(v.featured_media.id) : null;
      if (mediaId && !map.has(mediaId)) map.set(mediaId, v);
    });
    return map;
  }

  function getMediaIdFromThumbClick(targetEl) {
    // Works with your markup: li.thumbnail-list__item[data-target="...-MEDIAID"]
    const li = targetEl.closest('li.thumbnail-list__item[data-target]');
    if (!li) return null;

    const target = li.getAttribute('data-target') || '';
    return target.match(/-(\d+)$/)?.[1] || null;
  }

  function getOptionSelect() {
    // Your select: name="options[Image]"
    return document.querySelector('variant-selects select[name="options[Image]"]')
      || document.querySelector('variant-selects select[name^="options["]');
  }

  function triggerVariantChange(selectEl) {
    const variantSelects = selectEl.closest('variant-selects');

    // Trigger change on the select (what most themes listen to)
    selectEl.dispatchEvent(new Event('change', { bubbles: true }));

    // Some themes listen on the component wrapper as well
    if (variantSelects) {
      variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function init() {
    const product = getProduct();
    if (!product) return;

    const mediaToVariant = buildMediaToVariant(product);

    // One global delegated listener: always catches thumbnail clicks even if sliders rerender
    document.addEventListener('click', (e) => {
      const mediaId = getMediaIdFromThumbClick(e.target);
      if (!mediaId) return;

      const variant = mediaToVariant.get(String(mediaId));
      if (!variant?.option1) return;

      const selectEl = getOptionSelect();
      if (!selectEl) return;

      if (selectEl.value !== variant.option1) {
        selectEl.value = variant.option1;
        triggerVariantChange(selectEl);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();